import { createFileRoute } from '@tanstack/react-router';
import { RoleGuard } from '@/components/molecules/role-guard';
import { ToInvoice } from '@/pages/to-invoice';
import { useBillingWorklistAccess } from '@/pages/to-invoice/use-billing-worklist-access';
import { toInvoiceSearchSchema } from '@/routes/-shared/to-invoice-search-schema';

export const Route = createFileRoute('/protected/_layout/to-invoice')({
  validateSearch: toInvoiceSearchSchema,
  component: ToInvoiceRoute,
});

function ToInvoiceRoute() {
  const { canOpen, isLoading } = useBillingWorklistAccess();
  return (
    <RoleGuard hasAccess={canOpen} isLoading={isLoading}>
      <ToInvoice />
    </RoleGuard>
  );
}
